/*global google*/
import React from "react";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import DrawingManager from "react-google-maps/lib/components/drawing/DrawingManager";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import new_marker from '../assets/images/new_marker.svg';
import { interpolateRgb } from "d3-interpolate";
import "../assets/css/global.css";
import plus from '../assets/images/plus.svg';
import WKTReader from 'jsts/org/locationtech/jts/io/WKTReader';
import { intersects } from 'jsts/org/locationtech/jts/monkey';
import { polygon_stroke_color, polygon_fill_color, polygon_stroke_opacity, polygon_fill_opacity, polygon_stroke_width, polygon_fill_color_red } from "./constVariables";

export const initMap = (data, drawing_tool) => {
    // console.log("initMap = ", data)
    // defining boundary for map
    const INDIA_BOUNDS = {
        north: 35.513327,
        south: 6.4626999,
        west: 68.1097,
        east: 97.395358699999991
    };
    // Created Main map
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: 5,
        // center: { lat: -28.024, lng: 140.887 },
        center: { lat: -34.67059865843404, lng: 150.8618241046505 },
        restriction: {
            latLngBounds: INDIA_BOUNDS,
            strictBounds: false
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        // mapTypeId: 
        mapTypeId: "terrain",
    });
    // Created label to show when click on marker
    const infoWindow_marker = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: false
    });
    const infoWindow_polygon = new google.maps.InfoWindow({
        content: "<span class='label_polygon' style='color:red'> SOME MESSAGE </span>" // red message
    });
    // Add a marker clusterer to manage the markers.
    const markers = data.map((position, i) => {
        const marker = new google.maps.Marker({
            position,
            // icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            icon: new_marker,
            animation: google.maps.Animation.DROP,
        });
        const contentString =
            '<div id="content">' +
            '<div id="siteNotice">' +
            "</div>" +
            '<h1 id="firstHeading" class="firstHeading">' +
            position.name + ", " +
            "Area: " + position.count +
            "</h1>" +
            "<h3>" + position.state + ", " + position.lat + ", " + position.lng + ", </h3>" +
            '<div id="bodyContent">' +
            "<br>City Descripition Comes here " +
            "</div>" +
            "</div>";
        marker.setTitle(String(position.count));
        // markers can only be keyboard focusable when they have click listeners
        // open info window when marker is clicked
        // marker.addListener("click", () => {
        //         infoWindow_marker.setContent(name);
        //         infoWindow_marker.open(map, marker);
        // });
        marker.addListener("mouseover", function () {
            infoWindow_marker.setContent(contentString);
            infoWindow_marker.open(map, marker);
        });
        marker.addListener("mouseout", function () {
            infoWindow_marker.close();
        });
        return marker;
    });

    // Define the LatLng coordinates for the polygon's path.
    const triangleCoords = [
        { lat: 25.774, lng: -80.19 },
        { lat: 18.466, lng: -66.118 },
        { lat: 32.321, lng: -64.757 },
        { lat: 25.774, lng: -80.19 },
    ];
    const poly1 = [
        { lat: -34.67061103963261, lng: 150.86191110207892 },
        { lat: -34.670541000846676, lng: 150.86199894442416 },
        { lat: -34.67058070788218, lng: 150.8620445419774 },
        { lat: -34.67065019514853, lng: 150.86195871128893 },
    ]
    // Construct the polygon.
    const bermudaTriangle1 = new google.maps.Polygon({
        // paths: poly1,
        strokeColor: "#FF0000",
        strokeOpacity: 0.3,
        strokeWeight: 2,
        fillColor: "#396aff",
        fillOpacity: 0.8,
    });
    const poly2 = [
        { lat: -34.67063254759435, lng: 150.8619057376609 },
        { lat: -34.67057298707122, lng: 150.86198419227458 },
        { lat: -34.670625929760554, lng: 150.86205460026122 },
        { lat: -34.670680526873504, lng: 150.86197882785655 },
    ]
    // // Construct the polygon.
    const bermudaTriangle2 = new google.maps.Polygon({
        paths: poly2,
        strokeColor: "#FF0000",
        strokeOpacity: 0.3,
        strokeWeight: 2,
        fillColor: "#396aff",
        fillOpacity: 0.8,
    });
    // google.maps.event.addListener(bermudaTriangle2, 'click', function (event) {
    //     polygon(event)
    // });
    google.maps.event.addListener(bermudaTriangle1, 'mouseover', function (event) {
        polygon(event)
    });
    google.maps.event.addListener(bermudaTriangle1, 'mouseout', function (event) {
        infoWindow_polygon.close()
    });
    google.maps.event.addListener(bermudaTriangle2, 'mouseover', function (event) {
        polygon(event)
    });
    google.maps.event.addListener(bermudaTriangle2, 'mouseout', function (event) {
        infoWindow_polygon.close()
    });
    google.maps.event.addListener(map, 'click', function () {
        infoWindow_polygon.close();
        infoWindow_marker.close();
    });
    function polygon(event) {
        // console.log("Bermuda Triangle2 clicked");
        const contentString = "cddjfkjfkdjfkdjfkdjfkdjfkjf"
        // infoWindow_polygon.setContent(contentString);
        infoWindow_polygon.setPosition(event.latLng);
        infoWindow_polygon.open(map);
    }

    // Created a drawing tab
    if (drawing_tool === true) {
        const drawingManager = new google.maps.drawing.DrawingManager({
            // drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
                drawingModes: [
                    // google.maps.drawing.OverlayType.MARKER,
                    // google.maps.drawing.OverlayType.CIRCLE,
                    google.maps.drawing.OverlayType.POLYGON,
                    // google.maps.drawing.OverlayType.POLYLINE,
                    // google.maps.drawing.OverlayType.RECTANGLE,
                ],
            },
            markerOptions: {
                icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            },
            circleOptions: {
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                clickable: true,
                editable: true,
                zIndex: 1,
            },
            polygonOptions: {
                fillColor: "#396aff",
                fillOpacity: 0.1,
                strokeWeight: 3,
                clickable: true,
                editable: true,
                draggable: true,
                zIndex: 1,
            },

        });

        // // To hide:
        // drawingManager.setOptions({
        //     drawingControl: false
        // });

        // // To show:
        // drawingManager.setOptions({
        //     drawingControl: true
        // });
        var draw_polygon = [];
        google.maps.event.addDomListener(drawingManager, 'polygoncomplete', function (polygon) {
            draw_polygon.push(polygon);
            drawingManager.setDrawingMode(null)
            // // console.log(document.getElementById("edit-poly").disabled)
            // document.getElementById("edit-poly").disabled = false; document.getElementById("done-poly").disabled = false;
            // var path = []
            // polygon.getPath().getArray().forEach(function (position) {
            //     console.log('lat', position.lat(), 'lng', position.lng());
            //     path.push({ lat: position.lat(), lng: position.lng() })
            // });

            // bermudaTriangle1.setPath(path);
            // bermudaTriangle1.setMap(map);

            // polygon.setMap(null)
            google.maps.event.addListener(polygon, 'mouseout', function () {
                polygon.getPath().getArray().forEach(function (position) {
                    // console.log('lat', position.lat(), 'lng', position.lng());
                });
                // console.log("/n");
            });
            // console.log(path);
        });
        drawingManager.setMap(map)
    }

    // function editPoly() {
    //     bermudaTriangle1.setMap(null);
    //     draw_polygon[0].setMap(map);
    // }
    // function donePoly() {
    //     console.log("donePoly called");
    //     bermudaTriangle1.setMap(map);
    //     draw_polygon[0].setMap(null);
    // }
    // document.getElementById("edit-poly").addEventListener("click", () => editPoly());
    // document.getElementById("done-poly").addEventListener("click", () => donePoly());
    // function cluster_merged() {
    //     console.log("cluster merging")
    // }
    // function mouse() {
    //     console.log("mouse")
    // }

    var markerClusterer = new MarkerClusterer({ markers, map, renderer: { render: renderer } });

    // When click on cluster
    markerClusterer.onClusterClick = function (event, cluster, map) {
        map.setZoom(map.zoom + 2);
        var markers = cluster.markers;
        // console.log("%c Cluster Clicked", "background:wheat;color:red")
        map.setCenter(markers[0].getPosition());
    };
    markerClusterer.enableRetinaIcons = true;
    function normalize(min, max) {
        const delta = max - min;
        return val => ((val < min ? min : (val > max ? max : val)) - min) / delta;
    }
    function renderer({ count, position }, stats) {
        // console.log("%c Data = ", count, stats.clusters.markers)
        let nor = (count - stats.clusters.markers.min) / (stats.clusters.markers.max - stats.clusters.markers.min)
        const minFont = 12;
        const maxFont = 22;
        const minScale = 55;
        const maxScale = 80;
        // use d3-interpolateRgb to interpolate between red and blue
        const color = interpolateRgb("blue", "red")(nor);
        // create svg url with fill color
        const svg = window.btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" height="120" width="120">
        <circle cx="60px" cy="60px" r="36px"  fill="${color}" />
        <circle cx="60px" cy="60px" r="42px" fill-opacity="0.8" fill="${color}" />
        <circle cx="60px" cy="60px" r="48px" fill-opacity="0.5" fill="${color}" />
        <circle cx="60px" cy="60px" r="54px" fill-opacity="0.20" fill="${color}" />
        <circle cx="60px" cy="60px" r="60px" fill-opacity="0.20" fill="${color}" />
    </svg>`);
        // create marker using svg icon
        return new google.maps.Marker({
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(((maxScale - minScale) * nor) + minScale, ((maxScale - minScale) * nor) + minScale)
            },
            label: {
                text: String(count),
                color: "rgba(255,255,255,0.9)",
                fontSize: `${((maxFont - minFont) * nor) + minFont}px`
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
        });
    }

    bermudaTriangle1.setMap(map);
    bermudaTriangle2.setMap(map);
    // if (drawing_tool === true) {  }
}

export const initMapCluster = (data, setMapVINs, drawing_tool, area, zone, setAreaSort) => {
    // console.log("inside init Map cluster = ", area, zone)
    // defining boundary for map
    const INDIA_BOUNDS = {
        north: 35.513327,
        south: 6.4626999,
        west: 68.1097,
        east: 97.395358699999991
    };
    // Created Main map
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: 5,
        center: { lat: 21.511213, lng: 78.821097 },
        restriction: {
            latLngBounds: INDIA_BOUNDS,
            strictBounds: false
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        // mapTypeId: 
        mapTypeId: "terrain",
        gestureHandling: "cooperative",
    });
    // Created label to show when click on marker
    const infoWindow_marker = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: false
    });
    const infoWindow_polygon = new google.maps.InfoWindow({
        content: "<span class='label_polygon' style='color:red'> SOME MESSAGE </span>" // red message
    });
    const markers = data.map((position, i) => {
        const marker = new google.maps.Marker({
            position,
            // icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            icon: new_marker,
            // animation: google.maps.Animation.DROP,
        });
        const contentString =
            '<div id="content">' +
            '<div id="siteNotice">' +
            '</div>' +
            '<span id="firstHeading" class="firstHeading" style="font-size:1rem;font-weight:600;">' + position.vin_number + '</span>' +
            '</div';
        marker.setTitle(String(position.vin_number));
        marker.addListener("click", function () {
            infoWindow_marker.setContent(contentString);
            infoWindow_marker.open(map, marker);
        });
        map.addListener("click", function () {
            infoWindow_marker.close();
        });
        return marker;
    });

    google.maps.event.addListener(map, 'click', function () {
        infoWindow_polygon.close();
        infoWindow_marker.close();
    });
    var markerClusterer = new MarkerClusterer({ markers, map, renderer: { render: renderer } });
    // When click on cluster
    markerClusterer.onClusterClick = function (event, cluster, map) {
        map.setZoom(map.zoom + 2);
        var markers = cluster.markers;
        // console.log("%c Cluster Clicked", "background:wheat;color:red")
        map.setCenter(markers[0].getPosition());
    };
    markerClusterer.enableRetinaIcons = true;

    var pixelToLatlng = function (xcoor, ycoor) {
        var ne = map.getBounds().getNorthEast();
        var sw = map.getBounds().getSouthWest();
        var projection = map.getProjection();
        var topRight = projection.fromLatLngToPoint(ne);
        var bottomLeft = projection.fromLatLngToPoint(sw);
        //var scale = Math.pow(2, map.getZoom());
        var scale = 1 << map.getZoom();
        var newLatlng = projection.fromPointToLatLng(new google.maps.Point(xcoor / scale + bottomLeft.x, ycoor / scale + topRight.y));
        return newLatlng;
    };
    function latlngToPixel(center) {
        var overlay = new google.maps.OverlayView();
        overlay.draw = function () { };
        overlay.setMap(map);
        var proj = overlay.getProjection();
        return proj.fromLatLngToContainerPixel(center)
    }
    function renderer({ count, position }, stats) {
        // use d3-interpolateRgb to interpolate between red and blue
        const color = "blue";
        // create svg url with fill color
        const svg = window.btoa(`
            <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
            <circle cx="120" cy="120" opacity=".8" r="70" />    
            </svg>`);
        // create marker using svg icon
        return new google.maps.Marker({
            position: {
                lat: pixelToLatlng(latlngToPixel({ lat: position.lat(), lng: position.lng() }).x, latlngToPixel({ lat: position.lat(), lng: position.lng() }).y + 30).lat(),
                lng: position.lng()
            },
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(75, 75)
            },
            label: {
                text: String(count),
                color: "rgba(255,255,255,0.9)",
                fontSize: "12px"
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
        });
    }

    const showVisibleMarkers = () => {
        var bounds = map.getBounds();
        var vin_number = [];
        for (var i = 0; i < markers.length; i++) {
            var marker = markers[i]
            if (bounds.contains(marker.getPosition()) === true) {
                vin_number.push(marker.getTitle())
            }
        }
        setMapVINs(vin_number)
    }
    // if (setMapVINs) {
    //     google.maps.event.addListener(map, 'idle', function (e) {
    //         showVisibleMarkers();
    //     })
    // }
    const areaInfo = {}
    const zoneInfo = {}
    area?.map((d, i) => {
        const polygon = new google.maps.Polygon({
            paths: d['coordinates'],
            strokeColor: polygon_stroke_color,
            strokeOpacity: polygon_stroke_opacity,
            strokeWeight: polygon_stroke_width,
            fillColor: polygon_fill_color,
            fillOpacity: polygon_fill_opacity,
        });
        polygon.setMap(map);
        areaInfo["areaInfo" + i] = new google.maps.InfoWindow({
            content:
                '<div id="content" style="text-transform: capitalize">' +
                '<div id="siteNotice"></div>' +
                '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;">Area Name: ' + (d.name ? d.name : "-") + '</div>' +
                '</div>'
        });
        google.maps.event.addListener(polygon, 'click', function (event) {
            for (var key of Object.keys(areaInfo)) {
                areaInfo[key].close()
            }
            areaInfo["areaInfo0"].close()
            areaInfo["areaInfo" + i].setPosition(event.latLng);
            areaInfo["areaInfo" + i].open(map);
            setAreaSort({ domain: "area", name: d.name })
        });
        google.maps.event.addListener(map, 'click', function (event) {
            areaInfo["areaInfo" + i].close();
        });
    })

    zone?.map((d, i) => {
        const polygon = new google.maps.Polygon({
            paths: d['coordinates'],
            strokeColor: polygon_stroke_color,
            strokeOpacity: polygon_stroke_opacity,
            strokeWeight: polygon_stroke_width,
            fillColor: polygon_fill_color_red,
            fillOpacity: polygon_fill_opacity,
        });
        polygon.setMap(map);
        zoneInfo["zoneInfo" + i] = new google.maps.InfoWindow({
            content:
                '<div id="content" style="text-transform: capitalize">' +
                '<div id="siteNotice"></div>' +
                '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;">Zone Name: ' + (d.name ? d.name : "-") + '</div>' +
                '</div>'
        });
        google.maps.event.addListener(polygon, 'click', function (event) {
            for (var key of Object.keys(zoneInfo)) {
                zoneInfo[key].close()
            }
            zoneInfo["zoneInfo" + i].setPosition(event.latLng);
            zoneInfo["zoneInfo" + i].open(map);
            setAreaSort({ domain: "zone", name: d.name })
        });
        google.maps.event.addListener(map, 'click', function (event) {
            zoneInfo["zoneInfo" + i].close();
        });
    })
    google.maps.event.addListener(map, 'click', function (event) {
        setAreaSort({ domain: "all", name: "all" })
    });
}

export const initMap2 = () => {
    let map;
    let featureLayer;
    let infoWindow;
    map = new google.maps.Map(document.getElementById("map_container"), {
        center: { lat: 39.23, lng: -105.73 },
        zoom: 8,
        // In the cloud console, configure this Map ID with a style that enables the
        // "Administrative Area Level 2" Data Driven Styling type.
        mapId: "a3efe1c035bad51b", // <YOUR_MAP_ID_HERE>,
    });
    // Add the feature layer.
    //@ts-ignore
    featureLayer = map.getFeatureLayer("country");
    // Add the event listener for the feature layer.
    featureLayer.addListener("click", handlePlaceClick);
    infoWindow = new google.maps.InfoWindow({});
    // Apply style on load, to enable clicking.
    applyStyleToSelected();

    // Handle the click event.
    function handlePlaceClick(event) {
        let feature = event.features[0];

        // console.log(event);
        if (!feature.placeId) return;

        // Apply the style to the feature layer.
        applyStyleToSelected(feature.placeId);

        // Add the info window.
        let content =
            '<span style="font-size:small">Display name: ' +
            feature.displayName +
            "<br/> Place ID: " +
            feature.placeId +
            "<br/> Feature type: " +
            feature.featureType +
            "</span>";

        updateInfoWindow(content, event.latLng);
    }
    // Apply styles to the map.
    function applyStyleToSelected(placeid) {
        // Apply styles to the feature layer.
        featureLayer.style = (options) => {
            // Style fill and stroke for a polygon.
            if (placeid && options.feature.placeId == placeid) {
                return styleClicked;
            }
            // Style only the stroke for the entire feature type.
            return styleDefault;
        };
    }
    function updateInfoWindow(content, center) {
        infoWindow.setContent(content);
        infoWindow.setPosition(center);
        infoWindow.open({
            map,
            shouldFocus: false,
        });
    }
    const styleDefault = {
        strokeColor: "#810FCB",
        strokeOpacity: 1.0,
        strokeWeight: 2.0,
        fillColor: "white",
        fillOpacity: 0.1, // Polygons must be visible to receive click events.
    };
    const styleClicked = {
        ...styleDefault,
        fillColor: "#810FCB",
        fillOpacity: 0.5,
    };

    // featureLayer = map.getFeatureLayer("ADMINISTRATIVE_AREA_LEVEL_2");
    // featureLayer.addListener("click", handlePlaceClick);
    // console.log('featureLayer', featureLayer)
    // console.log('featureLayer style = ', featureLayer.style)
    // applyStyleToSelected();

    // const featureStyleOptions = {
    //     strokeColor: "#810FCB",
    //     strokeOpacity: 1.0,
    //     strokeWeight: 3.0,
    //     fillColor: "#810FCB",
    //     fillOpacity: 0.5,
    // };

    // // Apply the style to a single boundar
    // featureLayer.style = (options) => {
    //     console.log('options = ', options)
    //     if (options.feature.placeId == "ChIJ0zQtYiWsVHkRk8lRoB1RNPo") {
    //         // Hana, HI
    //         return featureStyleOptions;
    //     }
    // };

}

export const showData = (plant, zoom, area, setSelectedZone, drawingStatus, cluster) => {
    // console.log("data inside map container = ", plant, zoom, area, setSelectedZone, drawingStatus, cluster);
    // setSelectedZone("df")
    // defining boundary for map
    const INDIA_BOUNDS = {
        north: 35.513327,
        south: 6.4626999,
        west: 68.1097,
        east: 97.395358699999991
    };
    // Created Main map
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: 17,
        // center: { lat: -28.024, lng: 140.887 },
        center: plant,
        // center: { lat: 15.532294, lng: 74.931591 },
        // restriction: {
        //     latLngBounds: data,
        //     strictBounds: false
        // },
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        // mapTypeId: 
        mapTypeId: "terrain",
        gestureHandling: "cooperative",
    });
    // Created label to show when click on marker
    // const infoWindow_marker = new google.maps.InfoWindow({
    //     content: "",
    //     disableAutoPan: false
    // });
    const infoWindow_polygon = new google.maps.InfoWindow({
        content: "<span class='label_polygon' style='color:red'> SOME MESSAGE </span>" // red message
    });
    // Add a marker clusterer to manage the markers.
    // const markers = data.map((position, i) => {
    //     const marker = new google.maps.Marker({
    //         position
    //     });
    //     const contentString =
    //         '<div id="content">' +
    //         '<div id="siteNotice">' +
    //         "</div>" +
    //         '<h1 id="firstHeading" class="firstHeading">' +
    //         position.name + ", " +
    //         "Area: " + position.count +
    //         "</h1>" +
    //         "<h3>" + position.state + ", " + position.lat + ", " + position.lng + ", </h3>" +
    //         '<div id="bodyContent">' +
    //         "<br>City Descripition Comes here " +
    //         "</div>" +
    //         "</div>";
    //     marker.setTitle(String(position.count));
    //     // markers can only be keyboard focusable when they have click listeners
    //     // open info window when marker is clicked
    //     // marker.addListener("click", () => {
    //     //         infoWindow_marker.setContent(name);
    //     //         infoWindow_marker.open(map, marker);
    //     // });
    //     marker.addListener("mouseover", function () {
    //         infoWindow_marker.setContent(contentString);
    //         infoWindow_marker.open(map, marker);
    //     });
    //     marker.addListener("mouseout", function () {
    //         infoWindow_marker.close();
    //     });
    //     return marker;
    // });
    const ab = []
    // console.log("START THE GAME")
    const createPolygon = (data) => {
        // console.log("data inside createPolygon= ", data['coordinates']);
        var polygon = new google.maps.Polygon({
            path: data['coordinates'],
            strokeOpacity: 1,
            strokeColor: "red"
        });


        var lastPath = null,
            lastCenter = null;
        polygon.getPosition = function () {
            var path = this.getPath();
            if (lastPath === path) {
                return lastCenter;
            }
            lastPath = path;
            var bounds = new google.maps.LatLngBounds();
            path.forEach(function (latlng, i) {
                bounds.extend(latlng);
            });

            lastCenter = bounds.getCenter()
            return lastCenter;
        };
        polygon.setMap(map);
        // console.log("sdfghjkl;[[poiuytrew", polygon.getPosition().lat(), polygon.getPosition().lng(), data['area_name'], data['area_coordinates']);

        // polylist.push({ lat: polygon.getPosition().lat(), lng: polygon.getPosition().lng() });
        polylist.push(polygon);
        return polygon;
    }
    var polylist = []
    area.map((d, i) => {
        // console.log("dddddddd",d['area_coordinates'])
        // const area_parameter = new google.maps.Polygon({
        //     paths: d["area_coordinates"],
        //     strokeColor: "#7C7C7C",
        //     strokeOpacity: 0.8,
        //     strokeWeight: 2,
        //     fillColor: "#7C7C7C",
        //     fillOpacity: 0.35,
        // });
        // area_parameter.setMap(map);
        // const areaInfo = new google.maps.InfoWindow({
        //     content: `<span class='label_polygon' style='color:red'> ${d['name']} </span>` // red message
        // });
        // google.maps.event.addListener(area_parameter, 'mouseover', function (event) {
        //     areaInfo.setPosition(event.latLng);
        //     areaInfo.open(map);
        // });
        // google.maps.event.addListener(area_parameter, 'mouseout', function (event) {
        //     areaInfo.close()
        // });
        // console.log("aa114788 = ",area_parameter);
        // ab.push(area_parameter)
        var polyline = createPolygon(d);
        // console.log("gjgj =",polyline)
        // polylist.push(polyline);
    })
    // console.log(polylist)


    // polylist.map((d, i) => {
    //     console.log("Lat = " + d.getPosition().lat() + "long = " + d.getPosition().lng());
    // })
    var markerClusterer = new MarkerClusterer({ polylist, map, renderer: { render: renderer } });


    // const markers = major_cities.map((position, i) => {
    //     const marker = new google.maps.Marker({
    //         position
    //     });
    //     const contentString =
    //         '<div id="content">' +
    //         '<div id="siteNotice">' +
    //         "</div>" +
    //         '<h1 id="firstHeading" class="firstHeading">' +
    //         position.name + ", " +
    //         "Area: " + position.count +
    //         "</h1>" +
    //         "<h3>" + position.state + ", " + position.lat + ", " + position.lng + ", </h3>" +
    //         '<div id="bodyContent">' +
    //         "<br>City Descripition Comes here " +
    //         "</div>" +
    //         "</div>";
    //     marker.setTitle(String(position.count));

    //     return marker;
    // });
    // var markerClusterer = new MarkerClusterer({ markers, map });


    function renderer({ count, position }, stats) {
        // use d3-interpolateRgb to interpolate between red and blue
        const color = "blue";
        // create svg url with fill color
        const svg = window.btoa(`
      <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <circle cx="120" cy="120" opacity=".8" r="70" />    
      </svg>`);
        // create marker using svg icon
        return new google.maps.Marker({
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(75, 75)
            },
            label: {
                text: String(count),
                color: "rgba(255,255,255,0.9)",
                fontSize: "12px"
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
        });
    }


































    // console.log("object 1111111111111111111111111111111111111111111111111111111111111111111111111 = ", ab)
    // ab.map((a, i) => {
    //     console.log("a = ", a)
    // })

    // var markerClusterer2 = new MarkerClusterer({ ab, map });

    // const markers = data.map((position, i) => {
    //     const marker = new google.maps.Marker({
    //         position
    //     });
    //     const contentString =
    //         '<div id="content">' +
    //         '<div id="siteNotice">' +
    //         "</div>" +
    //         '<h1 id="firstHeading" class="firstHeading">' +
    //         position.name + ", " +
    //         "Area: " + position.count +
    //         "</h1>" +
    //         "<h3>" + position.state + ", " + position.lat + ", " + position.lng + ", </h3>" +
    //         '<div id="bodyContent">' +
    //         "<br>City Descripition Comes here " +
    //         "</div>" +
    //         "</div>";
    //     marker.setTitle(String(position.count));
    //     // markers can only be keyboard focusable when they have click listeners
    //     // open info window when marker is clicked
    //     // marker.addListener("click", () => {
    //     //         infoWindow_marker.setContent(name);
    //     //         infoWindow_marker.open(map, marker);
    //     // });
    //     marker.addListener("mouseover", function () {
    //         infoWindow_marker.setContent(contentString);
    //         infoWindow_marker.open(map, marker);
    //     });
    //     marker.addListener("mouseout", function () {
    //         infoWindow_marker.close();
    //     });
    //     return marker;
    // });
    // var markerClusterer = new MarkerClusterer({ ab, map });

    // // When click on cluster
    // markerClusterer.onClusterClick = function (event, cluster, map) {
    //     map.setZoom(map.zoom + 2);
    //     var markers = cluster.markers;
    //     console.log("%c Cluster Clicked", "background:wheat;color:red")
    //     map.setCenter(markers[0].getPosition());
    // };
    // markerClusterer.enableRetinaIcons = true;




    // data['area'].map((area, index) => {
    //     console.log("area = ", area)
    //     const area_parameter = new google.maps.Polygon({
    //         paths: area["coords"],
    //         strokeColor: "#FF0000",
    //         strokeOpacity: 0.8,
    //         strokeWeight: 2,
    //         fillColor: "#FF0000",
    //         fillOpacity: 0.35,
    //     });
    //     area_parameter.setMap(map);
    //     const areaInfo = new google.maps.InfoWindow({
    //         content: `<span class='label_polygon' style='color:red'> ${area['name']} </span>` // red message
    //     });
    //     google.maps.event.addListener(area_parameter, 'mouseover', function (event) {
    //         areaInfo.setPosition(event.latLng);
    //         areaInfo.open(map);
    //     });
    //     google.maps.event.addListener(area_parameter, 'mouseout', function (event) {
    //         areaInfo.close()
    //     });
    // })

    // Created a drawing tab
    if (drawingStatus) {
        const drawingManager = new google.maps.drawing.DrawingManager({
            // drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.MARKER,
                    // google.maps.drawing.OverlayType.CIRCLE,
                    google.maps.drawing.OverlayType.POLYGON,
                    // google.maps.drawing.OverlayType.POLYLINE,
                    // google.maps.drawing.OverlayType.RECTANGLE,
                ],
            },
            // markerOptions: {
            //     icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            // },
            circleOptions: {
                fillColor: "#7C7C7C",
                fillOpacity: 0.35,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                clickable: true,
                editable: true,
                zIndex: 1,
            },
            polygonOptions: {
                strokeColor: polygon_stroke_color,
                strokeOpacity: polygon_stroke_opacity,
                strokeWeight: polygon_stroke_width,
                fillColor: polygon_fill_color,
                fillOpacity: polygon_fill_opacity,
                clickable: true,
                editable: true,
                draggable: true,
                zIndex: 1,
            },

        });
        var draw_polygon = [];
        google.maps.event.addDomListener(drawingManager, 'polygoncomplete', function (polygon) {
            draw_polygon.push(polygon);
            drawingManager.setDrawingMode(null)
            // console.log("fdffd", polygon)
            // // console.log(document.getElementById("edit-poly").disabled)
            // document.getElementById("edit-poly").disabled = false; document.getElementById("done-poly").disabled = false;
            // var path = []
            // polygon.getPath().getArray().forEach(function (position) {
            //     console.log('lat', position.lat(), 'lng', position.lng());
            //     path.push({ lat: position.lat(), lng: position.lng() })
            // });

            // bermudaTriangle1.setPath(path);
            // bermudaTriangle1.setMap(map);

            // polygon.setMap(null)
            google.maps.event.addListener(polygon, 'mouseout', function () {
                const coords = []
                polygon.getPath().getArray().forEach(function (position) {
                    coords.push({ lat: position.lat(), lng: position.lng() })
                });
                // console.log("coords inside MapContainer = ", coords);
                setSelectedZone(coords)
            });
            // console.log(path);
        });
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            if (event.type === "marker") {
                console.log(event.type, event.overlay.position.lat(), event.overlay.position.lng())
            }
        });
        drawingManager.setMap(map)
    }




    // if (cluster) {
    //     const createPolygon = (path) => {
    //         var polygon = new google.maps.Polygon({
    //             path: path,
    //             strokeOpacity: 1,
    //             strokeColor: "red"
    //         });

    //         var lastPath = null,
    //             lastCenter = null;
    //         polygon.getPosition = function () {
    //             var path = this.getPath();
    //             if (lastPath == path) {
    //                 return lastCenter;
    //             }
    //             lastPath = path;
    //             var bounds = new google.maps.LatLngBounds();
    //             path.forEach(function (latlng, i) {
    //                 bounds.extend(latlng);
    //             });

    //             lastCenter = bounds.getCenter()
    //             return lastCenter;
    //         };
    //         polygon.setMap(mapCanvas);
    //         return polygon;
    //     }
    //     var mapCanvas;
    //     var mapDiv = document.getElementById("map_container");
    //     mapCanvas = new google.maps.Map(mapDiv, {
    //         mapTypeId: google.maps.MapTypeId.ROADMAP
    //     });

    //     // Generate bunch of path data
    //     var sw = new google.maps.LatLng(-19.448292, -152.012329);
    //     var ne = new google.maps.LatLng(76.150236, 58.925171);
    //     var bounds = new google.maps.LatLngBounds(sw, ne);
    //     mapCanvas.setCenter(bounds.getCenter());
    //     mapCanvas.setZoom(3);

    //     var baseLat, baseLng, category, json = [], path;
    //     for (var i = 0; i < 100; i++) {
    //         baseLat = Math.random() * (ne.lat() - sw.lat()) + sw.lat();
    //         baseLng = Math.random() * (ne.lng() - sw.lng()) + sw.lng();

    //         path = [
    //             new google.maps.LatLng(baseLat, baseLng),
    //             new google.maps.LatLng(baseLat + 1, baseLng + 1),
    //             new google.maps.LatLng(baseLat, baseLng + 2)
    //         ];
    //         json.push(path);
    //     }
    //     // console.log("json = ", json)
    //     var bounds, polyList = [];
    //     for (var i = 0, length = json.length; i < length; i++) {
    //         var polyline = createPolygon(json[i]);
    //         polyList.push(polyline);
    //     }
    //     // console.log("object = ", polyList)
    //     polyList.map((d,i)=>{
    //         console.log("d",d.getPosition().lat())
    //     })
    //     // var clusterer = new MarkerClusterer({ polyList, map });


    //     var markerClusterer = new MarkerClusterer({polyList,mapCanvas});
    //     var markerClusterer2 = new MarkerClusterer({ab,map});

    //     // When click on cluster
    //     // markerClusterer.onClusterClick = function (event, cluster, mapCanvas) {
    //     //     mapCanvas.setZoom(mapCanvas.zoom + 2);
    //     //     var markers = cluster.markers;
    //     //     console.log("%c Cluster Clicked", "background:wheat;color:red")
    //     //     mapCanvas.setCenter(markers[0].getPosition());
    //     // };
    //     // markerClusterer.enableRetinaIcons = true;

    //     // function renderer({ count, position }, stats) {
    //     //     // use d3-interpolateRgb to interpolate between red and blue
    //     //     const color = "blue";
    //     //     // create svg url with fill color
    //     //     const svg = window.btoa(`
    //     //   <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   </svg>`);
    //     //     // create marker using svg icon
    //     //     return new google.maps.Marker({
    //     //         position,
    //     //         icon: {
    //     //             url: `data:image/svg+xml;base64,${svg}`,
    //     //             scaledSize: new google.maps.Size(75, 75)
    //     //         },
    //     //         label: {
    //     //             text: String(count),
    //     //             color: "rgba(255,255,255,0.9)",
    //     //             fontSize: "12px"
    //     //         },
    //     //         // adjust zIndex to be above other markers
    //     //         zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
    //     //     });
    //     // }

    //     //     const infoWindow_marker = new google.maps.InfoWindow({
    //     //         content: "",
    //     //         disableAutoPan: false
    //     //     });
    //     //     cluster.map((d, i) => {
    //     //         console.log("d = ", d)
    //     //     })
    //     //     const markers = cluster.map((position, i) => {
    //     //         const marker = new google.maps.Marker({
    //     //             position
    //     //         });
    //     //         const contentString =
    //     //             '<div id="content">' +
    //     //             '<div id="siteNotice">' +
    //     //             "</div>" +
    //     //             '<h1 id="firstHeading" class="firstHeading">' +
    //     //             position.name + ", " +
    //     //             "Area: " + position.count +
    //     //             "</h1>" +
    //     //             "<h3>" + position.state + ", " + position.lat + ", " + position.lng + ", </h3>" +
    //     //             '<div id="bodyContent">' +
    //     //             "<br>City Descripition Comes here " +
    //     //             "</div>" +
    //     //             "</div>";
    //     //         marker.setTitle(String(position.count));
    //     //         // markers can only be keyboard focusable when they have click listeners
    //     //         // open info window when marker is clicked
    //     //         // marker.addListener("click", () => {
    //     //         //         infoWindow_marker.setContent(name);
    //     //         //         infoWindow_marker.open(map, marker);
    //     //         // });
    //     //         marker.addListener("mouseover", function () {
    //     //             infoWindow_marker.setContent(contentString);
    //     //             infoWindow_marker.open(map, marker);
    //     //         });
    //     //         marker.addListener("mouseout", function () {
    //     //             infoWindow_marker.close();
    //     //         });
    //     //         return marker;
    //     //     });
    //     //     var markerClusterer = new MarkerClusterer({ markers, map, renderer: { render: renderer } });

    //     //     // When click on cluster
    //     //     markerClusterer.onClusterClick = function (event, cluster, map) {
    //     //         map.setZoom(map.zoom + 2);
    //     //         var markers = cluster.markers;
    //     //         console.log("%c Cluster Clicked", "background:wheat;color:red")
    //     //         map.setCenter(markers[0].getPosition());
    //     //     };
    //     //     markerClusterer.enableRetinaIcons = true;

    //     //     function renderer({ count, position }, stats) {
    //     //         // use d3-interpolateRgb to interpolate between red and blue
    //     //         const color = "blue";
    //     //         // create svg url with fill color
    //     //         const svg = window.btoa(`
    //     //   <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   <circle cx="120" cy="120" opacity=".8" r="70" />    
    //     //   </svg>`);
    //     //         // create marker using svg icon
    //     //         return new google.maps.Marker({
    //     //             position,
    //     //             icon: {
    //     //                 url: `data:image/svg+xml;base64,${svg}`,
    //     //                 scaledSize: new google.maps.Size(75, 75)
    //     //             },
    //     //             label: {
    //     //                 text: String(count),
    //     //                 color: "rgba(255,255,255,0.9)",
    //     //                 fontSize: "12px"
    //     //             },
    //     //             // adjust zIndex to be above other markers
    //     //             zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
    //     //         });
    //     //     }
    // }
}

const createPolygon = (data, map, domain) => {
    // console.log("data start", data);
    var path = data['coordinates']
    var polygon = new google.maps.Polygon({
        path: path,
        strokeColor: domain === "zone" ? "#BE5252" : polygon_stroke_color,
        strokeOpacity: polygon_stroke_opacity,
        strokeWeight: polygon_stroke_width,
        fillColor: domain === "zone" ? "#FF0000" : polygon_fill_color,
        fillOpacity: polygon_fill_opacity,
    });
    var lastPath = null,
        lastCenter = null;
    polygon.getPosition = function () {
        var path = this.getPath();
        if (lastPath === path) {
            return lastCenter;
        }
        lastPath = path;
        var bounds = new google.maps.LatLngBounds();
        path.forEach(function (latlng, i) {
            bounds.extend(latlng);
        });

        lastCenter = bounds.getCenter()
        return lastCenter;
    };
    // polygon.setMap(map);
    return polygon;
}

const json_to_wkt = (coords) => {
    // console.log("coords = ", coords)
    var a = 'POLYGON(('
    coords.map((coord, index) => {
        // console.log("cord = ", Object.values(coord)[0] ? Object.values(coord)[0] : "err 0", "----", Object.values(coord)[1] ? Object.values(coord)[1] : "Errr 1", a)
        a = a + (Object.values(coord)[0] ? Object.values(coord)[0] : null) + " " + (Object.values(coord)[1] ? Object.values(coord)[1] : null) + ","
        // console.log("a = ", a)
    })
    // console.log("aaaaa = ", coords[0], Object.values(coords[0])[0] ? Object.values(coords[0])[0] : "error" + " " + Object.values(coords[0])[1] ? Object.values(coords[0])[1] : "error")
    a = a + (Object.values(coords[0])[0] ? Object.values(coords[0])[0] : null) + " " + (Object.values(coords[0])[1] ? Object.values(coords[0])[1] : null)
    a = a + "))";
    // console.log("a = ", a)
    return a
}

function UseJstsToTestForIntersection(wkt1, wkt2) {
    // console.log("wkt1, wkt2 = ", wkt1, wkt2)
    const wktReader = new WKTReader();
    var geom1 = wktReader.read(wkt1);
    var geom2 = wktReader.read(wkt2);
    // console.log("dddddddddd = ", geom1, geom2)
    // console.log("eeeeeeeeee = ", geom1.intersects(geom2))
    return geom1.intersects(geom2)
}

function deletePolygon(setSelectedZone, drawing_Manager, polygon) {
    drawing_Manager.setOptions({
        drawingControl: true
    });
    setSelectedZone([]);
    polygon.setMap(null);
    // console.log("delete = ", document.getElementById("floating-panel").style.display)
    document.getElementById("floating-panel").style.display = "none";
    return
}

function processDrawing(setSelectedZone, map, domain, areas, polygon, drawing_Manager, zones, subzones, parentZone) {
    const coords = []
    polygon.getPath().getArray().forEach(function (position) {
        coords.push({ lat: position.lat(), lng: position.lng() })
    });
    // console.log("coordinates = ",polygon,domain)
    if(domain == "Plant"){
        setSelectedZone(polygon)
    }
    else{
        setSelectedZone(coords)
    }
    class USGSOverlay extends google.maps.OverlayView {
        map;
        div;
        constructor(map, div) {
            super();
            this.map = map;
            this.div = div;
        }
        /**
         * onAdd is called when the map's panes are ready and the overlay has been added to the map.
         */
        onAdd() {
            // Add the element to the "overlayLayer" pane.
            const panes = this.getPanes();
            panes.floatPane.appendChild(this.div);
        }
        draw() {
            var bounds = this.map.getBounds();
            //     var areaBounds = {
            //         north: bounds.getNorthEast().lat(),
            //         south: bounds.getSouthWest().lat(),
            //         east: bounds.getNorthEast().lng(),
            //         west: bounds.getSouthWest().lng()
            //    };
            const overlayProjection = this.getProjection();
            const sw = overlayProjection.fromLatLngToDivPixel(
                bounds.getSouthWest()
            );
            const ne = overlayProjection.fromLatLngToDivPixel(
                bounds.getNorthEast()
            );

            // Resize the image's div to fit the indicated dimensions.
            if (this.div) {
                this.div.style.left = sw.x + "px";
                this.div.style.top = ne.y + "px";
                this.div.style.width = ne.x - sw.x + "px";
                this.div.style.height = sw.y - ne.y + "px";
            }
        }
        /**
         * The onRemove() method will be called automatically from the API if
         * we ever set the overlay's map property to 'null'.
         */
        onRemove() {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                delete this.div;
            }
        }
        /**
         *  Set the visibility to 'hidden' or 'visible'.
         */
        hide() {
            // console.log("inside hide")
            if (this.div) {
                this.div.style.visibility = "hidden";
            }
        }
        show() {
            if (this.div) {
                this.div.style.visibility = "visible";
            }
        }
        toggle() {
            if (this.div) {
                if (this.div.style.visibility === "hidden") {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
        toggleDOM(map) {
            if (this.getMap()) {
                this.setMap(null);
            } else {
                this.setMap(map);
            }
        }
    }

    if (domain === "Area") {
        document.getElementById("floating-panel").style.display = "block";
        document.getElementById("floating-panel").addEventListener("click", () => deletePolygon(setSelectedZone, drawing_Manager, polygon));
        drawing_Manager.setOptions({
            drawingControl: false
        });
        areas.map((area) => {
            const a = []
            area.getPath().getArray().forEach(function (position) {
                a.push({ lat: position.lat(), lng: position.lng() })
            });
            if (UseJstsToTestForIntersection(json_to_wkt(a), json_to_wkt(coords))) {
                deletePolygon(setSelectedZone, drawing_Manager, polygon);
                const area_error_div = document.createElement("div");
                area_error_div.style.position = "absolute";
                area_error_div.style.background = "rgba(0,0,0,0.5)";
                area_error_div.innerHTML = `<div tabindex="-1" style="width:487px;border:solid 1px #70707060;height:177px;font-family:sans-serif;display:block;background-color:white;margin:29vh auto;outline:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;">
                    <div style="background:#FFA222;text-align:left;font-weight:500;font-family: sans-serif;padding:10px 14px;color:#fff;display:flex;align-items:center;justify-content:space-between;font-size:16px">
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <span style="display: flex;"> 
                                <svg class="MuiSvgIcon-root MuiSvgIcon-fontSize1rem" style="width:1rem;height:1rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:1em;height:1em;display:inline-block;fill:currentColor;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbUpIcon" x="0px" y="0px">
                                    <path d="M 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 5.371094 18.628906 0 12 0 Z M 12 2 C 17.523438 2 22 6.476563 22 12 C 22 17.523438 17.523438 22 12 22 C 6.476563 22 2 17.523438 2 12 C 2 6.476563 6.476563 2 12 2 Z M 12 5.8125 C 11.816406 5.8125 11.664063 5.808594 11.5 5.84375 C 11.335938 5.878906 11.183594 5.96875 11.0625 6.0625 C 10.941406 6.15625 10.851563 6.285156 10.78125 6.4375 C 10.710938 6.589844 10.6875 6.769531 10.6875 7 C 10.6875 7.226563 10.710938 7.40625 10.78125 7.5625 C 10.851563 7.71875 10.941406 7.84375 11.0625 7.9375 C 11.183594 8.03125 11.335938 8.085938 11.5 8.125 C 11.664063 8.164063 11.816406 8.1875 12 8.1875 C 12.179688 8.1875 12.371094 8.164063 12.53125 8.125 C 12.691406 8.085938 12.816406 8.03125 12.9375 7.9375 C 13.058594 7.84375 13.148438 7.71875 13.21875 7.5625 C 13.289063 7.410156 13.34375 7.226563 13.34375 7 C 13.34375 6.769531 13.289063 6.589844 13.21875 6.4375 C 13.148438 6.285156 13.058594 6.15625 12.9375 6.0625 C 12.816406 5.96875 12.691406 5.878906 12.53125 5.84375 C 12.371094 5.808594 12.179688 5.8125 12 5.8125 Z M 10.78125 9.15625 L 10.78125 18.125 L 13.21875 18.125 L 13.21875 9.15625 Z"></path>
                                </svg>
                            </span>
                            <span style="margin-left:2rem;">Info</span>
                        </div>
                        <svg class="MuiSvgIcon-root MuiSvgIcon-fontSize1rem" style="cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:1em;height:1em;display:inline-block;fill:currentColor;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon">
                            <path
                                d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                            </path>
                        </svg>
                    </div>
                    <div style="color:#FFA222;text-align:left;font-weight:500;font-family: sans-serif;padding:15px 15px 0;display:flex;align-items:center;justify-content:space-between;font-size:14px">Note: Please clear the following error</div>
                    <div style="background-color:#dadada3d;height:55px;margin:15px;padding:15px 0 0 15px;">
                        <p style="font-weight:700;color:#8B8B8B;text-align:left;letter-spacing:0px;opacity:1;margin:unset; font-size: 16px;">Drawn area should not overlap another area</p>
                    </div>
                </div>`
                const overlay = new USGSOverlay(map, area_error_div);
                overlay.setMap(map);
                google.maps.event.addDomListener(area_error_div, 'click', function () {
                    overlay.hide();
                });
                return null
            }
        })
    }
    else if (domain === "Zone") {
        document.getElementById("floating-panel").style.display = "block";
        document.getElementById("floating-panel").addEventListener("click", () => deletePolygon(setSelectedZone, drawing_Manager, polygon));
        drawing_Manager.setOptions({
            drawingControl: false
        });
        let result = false;
        // console.log("subzone Zone = ", zones, subzones, parentZone)
        if (zones.length > 0 && parentZone) {
            zones?.map((zone) => {
                coords.map((coord) => {
                    const resultPath = google.maps.geometry.poly.containsLocation(coord, zone);
                    if (!resultPath) {
                        result = "zone";
                    }
                })
            })
        } else {
            areas.map((area) => {
                coords.map((coord) => {
                    const resultPath = google.maps.geometry.poly.containsLocation(coord, area);
                    if (!resultPath) {
                        result = "area";
                    }
                })
            })
        }
        if (result) {
            deletePolygon(setSelectedZone, drawing_Manager, polygon);
            const zone_error_div = document.createElement("div");
            zone_error_div.style.position = "absolute";
            zone_error_div.style.background = "rgba(0,0,0,0.5)";
            zone_error_div.innerHTML = `<div tabindex="-1" style="width:487px;border:solid 1px #70707060;height:177px;font-family:sans-serif;display:block;background-color:white;margin:29vh auto;outline:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;">
                <div style="background:#FFA222;text-align:left;font-weight:500;font-family: sans-serif;padding:10px 14px;color:#fff;display:flex;align-items:center;justify-content:space-between;font-size:16px">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span style="display: flex;"> 
                            <svg class="MuiSvgIcon-root MuiSvgIcon-fontSize1rem" style="width:1rem;height:1rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:1em;height:1em;display:inline-block;fill:currentColor;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbUpIcon" x="0px" y="0px">
                                <path d="M 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 5.371094 18.628906 0 12 0 Z M 12 2 C 17.523438 2 22 6.476563 22 12 C 22 17.523438 17.523438 22 12 22 C 6.476563 22 2 17.523438 2 12 C 2 6.476563 6.476563 2 12 2 Z M 12 5.8125 C 11.816406 5.8125 11.664063 5.808594 11.5 5.84375 C 11.335938 5.878906 11.183594 5.96875 11.0625 6.0625 C 10.941406 6.15625 10.851563 6.285156 10.78125 6.4375 C 10.710938 6.589844 10.6875 6.769531 10.6875 7 C 10.6875 7.226563 10.710938 7.40625 10.78125 7.5625 C 10.851563 7.71875 10.941406 7.84375 11.0625 7.9375 C 11.183594 8.03125 11.335938 8.085938 11.5 8.125 C 11.664063 8.164063 11.816406 8.1875 12 8.1875 C 12.179688 8.1875 12.371094 8.164063 12.53125 8.125 C 12.691406 8.085938 12.816406 8.03125 12.9375 7.9375 C 13.058594 7.84375 13.148438 7.71875 13.21875 7.5625 C 13.289063 7.410156 13.34375 7.226563 13.34375 7 C 13.34375 6.769531 13.289063 6.589844 13.21875 6.4375 C 13.148438 6.285156 13.058594 6.15625 12.9375 6.0625 C 12.816406 5.96875 12.691406 5.878906 12.53125 5.84375 C 12.371094 5.808594 12.179688 5.8125 12 5.8125 Z M 10.78125 9.15625 L 10.78125 18.125 L 13.21875 18.125 L 13.21875 9.15625 Z"></path>
                            </svg>
                        </span>
                        <span style="margin-left:2rem;">Info</span>
                    </div>
                    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSize1rem" style="cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:1em;height:1em;display:inline-block;fill:currentColor;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon">
                        <path
                            d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                        </path>
                    </svg>
                </div>
                <div style="color:#FFA222;text-align:left;font-weight:500;font-family: sans-serif;padding:15px 15px 0;display:flex;align-items:center;justify-content:space-between;font-size:14px">Note: Please clear the following error</div>
                <div style="background-color:#dadada3d;height:55px;margin:15px;padding:15px 0 0 15px;">
                    <p style="font-weight:700;color:#8B8B8B;text-align:left;letter-spacing:0px;opacity:1;margin:unset; font-size: 16px;">Drawn zone should be inside ${result === "zone" ? "parent zone" : "area"}</p>
                </div>
            </div>`
            const overlay = new USGSOverlay(map, zone_error_div);
            overlay.setMap(map);
            google.maps.event.addDomListener(zone_error_div, 'click', function () {
                overlay.hide();
            });
        }
        // console.log("result = ", result);
        let subzone_result = false;
        if (!result && subzones.length > 0) {
            // (parentZone?subzones:zones).map((subzone) => {
            subzones.map((subzone) => {
                const a = []
                subzone.getPath().getArray().forEach(function (position) {
                    a.push({ lat: position.lat(), lng: position.lng() })
                });
                // console.log("inside if = ", parentZone, subzone, a)
                if (UseJstsToTestForIntersection(json_to_wkt(a), json_to_wkt(coords))) {
                    subzone_result = true
                    return null
                }
            })
        }
        // console.log("subzone_result = ", subzone_result)
        if (subzone_result) {
            deletePolygon(setSelectedZone, drawing_Manager, polygon);
            const sunzone_error_div = document.createElement("div");
            sunzone_error_div.style.position = "absolute";
            sunzone_error_div.style.background = "rgba(0,0,0,0.5)";
            sunzone_error_div.innerHTML = `<div tabindex="-1" style="width:487px;border:solid 1px #70707060;height:177px;font-family:sans-serif;display:block;background-color:white;margin:29vh auto;outline:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;">
                        <div style="background:#FFA222;text-align:left;font-weight:500;font-family: sans-serif;padding:10px 14px;color:#fff;display:flex;align-items:center;justify-content:space-between;font-size:16px">
                            <div style="display: flex; align-items: center; justify-content: space-between;">
                                <span style="display: flex;"> 
                                    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSize1rem" style="width:1rem;height:1rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:1em;height:1em;display:inline-block;fill:currentColor;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbUpIcon" x="0px" y="0px">
                                        <path d="M 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 5.371094 18.628906 0 12 0 Z M 12 2 C 17.523438 2 22 6.476563 22 12 C 22 17.523438 17.523438 22 12 22 C 6.476563 22 2 17.523438 2 12 C 2 6.476563 6.476563 2 12 2 Z M 12 5.8125 C 11.816406 5.8125 11.664063 5.808594 11.5 5.84375 C 11.335938 5.878906 11.183594 5.96875 11.0625 6.0625 C 10.941406 6.15625 10.851563 6.285156 10.78125 6.4375 C 10.710938 6.589844 10.6875 6.769531 10.6875 7 C 10.6875 7.226563 10.710938 7.40625 10.78125 7.5625 C 10.851563 7.71875 10.941406 7.84375 11.0625 7.9375 C 11.183594 8.03125 11.335938 8.085938 11.5 8.125 C 11.664063 8.164063 11.816406 8.1875 12 8.1875 C 12.179688 8.1875 12.371094 8.164063 12.53125 8.125 C 12.691406 8.085938 12.816406 8.03125 12.9375 7.9375 C 13.058594 7.84375 13.148438 7.71875 13.21875 7.5625 C 13.289063 7.410156 13.34375 7.226563 13.34375 7 C 13.34375 6.769531 13.289063 6.589844 13.21875 6.4375 C 13.148438 6.285156 13.058594 6.15625 12.9375 6.0625 C 12.816406 5.96875 12.691406 5.878906 12.53125 5.84375 C 12.371094 5.808594 12.179688 5.8125 12 5.8125 Z M 10.78125 9.15625 L 10.78125 18.125 L 13.21875 18.125 L 13.21875 9.15625 Z"></path>
                                    </svg>
                                </span>
                                <span style="margin-left:2rem;">Info</span>
                            </div>
                            <svg class="MuiSvgIcon-root MuiSvgIcon-fontSize1rem" style="cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:1em;height:1em;display:inline-block;fill:currentColor;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;transition:fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon">
                                <path
                                    d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                                </path>
                            </svg>
                        </div>
                        <div style="color:#FFA222;text-align:left;font-weight:500;font-family: sans-serif;padding:15px 15px 0;display:flex;align-items:center;justify-content:space-between;font-size:14px">Note: Please clear the following error</div>
                        <div style="background-color:#dadada3d;height:55px;margin:15px;padding:15px 0 0 15px;">
                            <p style="font-weight:700;color:#8B8B8B;text-align:left;letter-spacing:0px;opacity:1;margin:unset; font-size: 16px;">Drawn zone should not overlap another zone</p>
                        </div>
                    </div>`
            const overlay = new USGSOverlay(map, sunzone_error_div);
            overlay.setMap(map);
            google.maps.event.addDomListener(sunzone_error_div, 'click', function () {
                overlay.hide();
            });
        }
    }

}

const drawingManager = (setSelectedZone, map, domain, areas, zone, subzone, parentZone) => {
    document.getElementById('floating-panel').style.display = 'none';
    document.getElementById("floating-panel").innerHTML = domain ? "Delete " + domain : " Delete Polygon";
    const drawing_Manager = new google.maps.drawing.DrawingManager({
        // drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
            drawingModes: [
                // google.maps.drawing.OverlayType.MARKER,
                // google.maps.drawing.OverlayType.CIRCLE,
                google.maps.drawing.OverlayType.POLYGON,
                // google.maps.drawing.OverlayType.POLYLINE,
                // google.maps.drawing.OverlayType.RECTANGLE,
            ],
        },
        // markerOptions: {
        //     icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        // },
        polygonOptions: {
            fillColor: "#7C7C7C",
            fillOpacity: 0.1,
            strokeWeight: 3,
            clickable: true,
            editable: true,
            draggable: true,
            zIndex: 1,
        },
    });
    var esc_pressed = false;
    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
            esc_pressed = true;
            drawing_Manager.setDrawingMode(null); // To terminate the drawing, will result in autoclosing of the shape being drawn.
        }
    };
    google.maps.event.addDomListener(drawing_Manager, 'polygoncomplete', function (polygon) {
        if (!esc_pressed) {
            drawing_Manager.setDrawingMode(null);
            google.maps.event.addListener(polygon.getPath(), 'set_at', function (event) {
                processDrawing(setSelectedZone, map, domain, areas, polygon, drawing_Manager, parentZone ? zone : [], parentZone ? subzone : zone, parentZone)
            });
            google.maps.event.addListener(polygon.getPath(), 'insert_at', function () {
                processDrawing(setSelectedZone, map, domain, areas, polygon, drawing_Manager, parentZone ? zone : [], parentZone ? subzone : zone, parentZone)
            });
            processDrawing(setSelectedZone, map, domain, areas, polygon, drawing_Manager, parentZone ? zone : [], parentZone ? subzone : zone, parentZone)
        }
        else {
            polygon.setMap(null);
            esc_pressed = false;
        }
    });
    google.maps.event.addListener(drawing_Manager, 'overlaycomplete', function (event) {
        if (event.type === "marker") {
            console.log(event.type, event.overlay.position.lat(), event.overlay.position.lng())
        }
        if (event.type === "rectangle") {
            console.log(event.overlay.getBounds().toJSON())
        }
    });
    return drawing_Manager;
}
const onEditt = (polygonn) => {
    console.log("polygon edited")
    // polygonn.getPath().getArray().forEach((ee) => {
    //     console.log("lat: ", ee.lat(), ", lng: ", ee.lng())
    // })
}
export const createCoords = (plant, zoom, area, zone, setSelectedZone, drawingStatus, overlay, domain, parentZone, vins, plant_coords, plants_coords_editable) => {
    // console.log("%c data inside map container", "font-size:14px;color:cadetblue", plant, zoom, area, zone, drawingStatus, overlay, domain, parentZone, vins, plant_coords)
    if (setSelectedZone && domain !== 'Plant') { setSelectedZone([]) }
    // Created Main map
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: zoom ? zoom : 17,
        center: plant,
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        restriction: {
            latLngBounds: INDIA_BOUNDS,
            strictBounds: false
        },
        navigationControl: true,
        // mapTypeId: 
        mapTypeId: "terrain",
        gestureHandling: "cooperative",
    });

    class USGSOverlay extends google.maps.OverlayView {
        map;
        div;
        constructor(map, div) {
            super();
            this.map = map;
            this.div = div;
        }
        /**
         * onAdd is called when the map's panes are ready and the overlay has been added to the map.
         */
        onAdd() {
            // Add the element to the "overlayLayer" pane.
            const panes = this.getPanes();
            panes.floatPane.appendChild(this.div);
        }
        draw() {
            var bounds = this.map.getBounds();
            //     var areaBounds = {
            //         north: bounds.getNorthEast().lat(),
            //         south: bounds.getSouthWest().lat(),
            //         east: bounds.getNorthEast().lng(),
            //         west: bounds.getSouthWest().lng()
            //    };
            const overlayProjection = this.getProjection();
            const sw = overlayProjection.fromLatLngToDivPixel(
                bounds.getSouthWest()
            );
            const ne = overlayProjection.fromLatLngToDivPixel(
                bounds.getNorthEast()
            );

            // Resize the image's div to fit the indicated dimensions.
            if (this.div) {
                this.div.style.left = sw.x + "px";
                this.div.style.top = ne.y + "px";
                this.div.style.width = ne.x - sw.x + "px";
                this.div.style.height = sw.y - ne.y + "px";
            }
        }
        /**
         * The onRemove() method will be called automatically from the API if
         * we ever set the overlay's map property to 'null'.
         */
        onRemove() {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                delete this.div;
            }
        }
        /**
         *  Set the visibility to 'hidden' or 'visible'.
         */
        hide() {
            // console.log("inside hide")
            if (this.div) {
                this.div.style.visibility = "hidden";
            }
        }
        show() {
            if (this.div) {
                this.div.style.visibility = "visible";
            }
        }
        toggle() {
            if (this.div) {
                if (this.div.style.visibility === "hidden") {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
        toggleDOM(map) {
            if (this.getMap()) {
                this.setMap(null);
            } else {
                this.setMap(map);
            }
        }
    }

    if (overlay) {
        const plot_div = document.createElement("div");
        plot_div.style.position = "absolute";
        plot_div.innerHTML = `<div style="width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;align-items: center;justify-content: center;cursor:pointer;z-index:99999">
                <div style="background: rgba(255, 255, 255, 0.8);border-radius: 4px;display: flex; align-items: center;justify-content: center;flex-direction: column;padding: 1rem;gap: 0.1rem;height: 30%;aspect-ratio: 16 / 9;">
                    <img style="width: 2.5rem;" src=${plus}>
                    <span style="font-family: 'Open Sans'; font-style: normal; font-weight: 700; font-size: 24px; line-height: 49px;white-space: nowrap; color: #707070">Plot ${domain}</span>
                </div>
            </div>`

        const overlay = new USGSOverlay(map, plot_div);
        overlay.setMap(map);
        // google.maps.event.trigger(map, 'mouseover', null);
        google.maps.event.addDomListener(plot_div, 'mouseover', function (e) {
            e.stopPropagation();
        });
        google.maps.event.addDomListener(plot_div, 'mouseout', function (e) {
            e.stopPropagation();
        });
        google.maps.event.addDomListener(plot_div, 'click', function (e) {
            e.stopPropagation();
            overlay.hide();
        });
    }
    const area_poly = []
    const zone_poly = []
    const subzone_poly = []
    const plant_poly = []
    const infoWindow_marker = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: false
    });

    if(plant_coords?.coordinates.length>0){
    plant_coords?.coordinates?.map((d, i) => {
        // var polygon = createPolygon(d, map, 'plant', plants_coords_editable);
        // plant_coords
        // polygon.setMap(map);
        // console.log('plant = ', plant_coords);
        // var path = d
        var polygon = new google.maps.Polygon({
            path: d,
            strokeColor: domain === "zone" ? "#BE5252" : polygon_stroke_color,
            strokeOpacity: polygon_stroke_opacity,
            strokeWeight: polygon_stroke_width,
            fillColor: domain === "zone" ? "#FF0000" : polygon_fill_color,
            fillOpacity: polygon_fill_opacity,
            editable: plants_coords_editable,
        });
        polygon.setMap(map);
        google.maps.event.addListener(polygon.getPath(), 'set_at', function (poly) { onEditt(polygon) });

        if (domain == "Plant") {
            var bounds = new google.maps.LatLngBounds();
            polygon.getPath().forEach(function (path, index) {
                bounds.extend(path);
            });
            map.fitBounds(bounds);
            // console.log("plant = ", d)
        }
        // const plantInfo = new google.maps.InfoWindow({
        //     // content: `<h3 class='label_polygon' style='color:red'> ${current_zone?.name} </h3>` // red message
        //     content:
        //         '<div id="content" style="text-transform: capitalize">' +
        //         '<div id="siteNotice"></div>' +
        //         '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0"> Plant Name: ' + (d.plant_name ? d.plant_name : d.name) + '</div>' +
        //         '</div>'
        // });
        // google.maps.event.addListener(polygon, "click", function (event) {
        //     plantInfo.setPosition(event.latLng);
        //     plantInfo.open(map);
        // });
        // google.maps.event.addListener(map, 'click', function (event) {
        //     plantInfo.close()
        // });
        plant_poly.push(polygon);
    })
}

    area?.map((d, i) => {
        var polygon = createPolygon(d, map);
        polygon.setMap(map);
        if (domain == "Zone") {
            var bounds = new google.maps.LatLngBounds();
            polygon.getPath().forEach(function (path, index) {
                bounds.extend(path);
            });
            map.fitBounds(bounds);
        }
        // console.log("area = ", d)
        const areaInfo = new google.maps.InfoWindow({
            // content: `<h3 class='label_polygon' style='color:red'> ${current_zone?.name} </h3>` // red message
            content:
                '<div id="content" style="text-transform: capitalize">' +
                '<div id="siteNotice"></div>' +
                '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0"> Area Name: ' + (d.area_name ? d.area_name : d.name) + '</div>' +
                '</div>'
        });
        google.maps.event.addListener(polygon, "click", function (event) {
            areaInfo.setPosition(event.latLng);
            areaInfo.open(map);
        });
        google.maps.event.addListener(map, 'click', function (event) {
            areaInfo.close()
        });
        area_poly.push(polygon);
    })

    if (zone?.length > 0) {
        zone?.map((d, i) => {
            var polygon = createPolygon(d, map, "zone");
            polygon.setMap(map);
            const zoneInfo = new google.maps.InfoWindow({
                // content: `<h3 class='label_polygon' style='color:red'> ${current_zone?.name} </h3>` // red message
                content:
                    '<div id="content" style="text-transform: capitalize">' +
                    '<div id="siteNotice"></div>' +
                    '<div id="firstHeading" class="firstHeading" style="font-size: 1rem;font-weight: 800;margin: 0 0 10px 0">Zone Name: ' + (d.zone_name ? d.zone_name : d.name) + '</div>' +
                    // '<div id="bodyContent">' + current_zone?.description + '</div>' +
                    '</div>'
            });
            google.maps.event.addListener(polygon, 'click', function (event) {
                zoneInfo.setPosition(event.latLng);
                zoneInfo.open(map);
            });
            google.maps.event.addListener(map, 'click', function (event) {
                zoneInfo.close()
            });
            zone_poly.push(polygon);
        })
        zone[0]?.subzone_data?.map(d => {
            var polygon = createPolygon(d, map, "area");
            polygon.setMap(map);
            const subzoneInfo = new google.maps.InfoWindow({
                // content: `<h3 class='label_polygon' style='color:red'> ${current_zone?.name} </h3>` // red message
                content:
                    '<div id="content" style="text-transform: capitalize">' +
                    '<div id="siteNotice"></div>' +
                    '<div id="firstHeading" class="firstHeading" style="font-size: 1rem;font-weight: 800;margin: 0 0 10px 0">Area Name: ' + d.zone_name + '</div>' +
                    // '<div id="bodyContent">' + current_zone?.description + '</div>' +
                    '</div>'
            });
            // google.maps.event.addListener(polygon, 'mouseover', function (event) {
            //     subzoneInfo.setPosition(event.latLng);
            //     subzoneInfo.open(map);
            // });
            // google.maps.event.addListener(polygon, 'mouseout', function (event) {
            //     subzoneInfo.close()
            // });
            google.maps.event.addListener(polygon, "click", function (event) {
                subzoneInfo.setPosition(event.latLng);
                subzoneInfo.open(map);
            });
            google.maps.event.addListener(map, 'click', function (event) {
                subzoneInfo.close()
            });
            subzone_poly.push(polygon);
        })
    }
    if (drawingStatus) {
        var DrawingManager = drawingManager(setSelectedZone, map, domain, area_poly, zone_poly, subzone_poly, parentZone);
        // google.maps.event.addDomListener(map, 'click', function () {
        //     console.log("trigger called");
        //     DrawingManager.setMap(map);
        // });
        google.maps.event.addDomListener(map, 'click', function () {
            DrawingManager.setMap(map);
        });
    }

    if (vins) {
        // console.log("vins = ", vins)
        const infoWindow_marker = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: false
        });
        const infoWindow_polygon = new google.maps.InfoWindow({
            content: "<span class='label_polygon' style='color:red'> SOME MESSAGE </span>" // red message
        });
        const markers = vins.map((position, i) => {
            const marker = new google.maps.Marker({
                position: position.coordinates[0],
                // icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
                icon: new_marker,
                // animation: google.maps.Animation.DROP,
            });
            const contentString =
                '<div id="content">' +
                '<div id="siteNotice">' +
                '</div>' +
                '<span id="firstHeading" class="firstHeading" style="font-size:1rem;font-weight:600;">' + position.vin_number + '</span>' +
                '</div';
            marker.setTitle(String(position.vin_number));
            marker.addListener("click", function () {
                infoWindow_marker.setContent(contentString);
                infoWindow_marker.open(map, marker);
            });
            // marker.addListener("mouseout", function () {
            //     infoWindow_marker.close();
            // });
            return marker;
        });

        google.maps.event.addListener(map, 'click', function () {
            infoWindow_polygon.close();
            infoWindow_marker.close();
        });
        var markerClusterer = new MarkerClusterer({ markers, map, renderer: { render: renderer } });
        // When click on cluster
        markerClusterer.onClusterClick = function (event, cluster, map) {
            map.setZoom(map.zoom + 2);
            var markers = cluster.markers;
            // console.log("%c Cluster Clicked", "background:wheat;color:red")
            map.setCenter(markers[0].getPosition());
        };
        markerClusterer.enableRetinaIcons = true;

        function renderer({ count, position }, stats) {
            // use d3-interpolateRgb to interpolate between red and blue
            const color = "blue";
            // create svg url with fill color
            const svg = window.btoa(`
      <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <circle cx="120" cy="120" opacity=".8" r="70" />    
      </svg>`);
            // create marker using svg icon
            return new google.maps.Marker({
                position,
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(75, 75)
                },
                label: {
                    text: String(count),
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "12px"
                },
                // adjust zIndex to be above other markers
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
            });
        }
    }

}

export const zoneDetailsMap = (plant, zoom, area, current_zone, zones, domain, vins) => {
    // console.log("data inside map container = ", plant, zoom, area, current_zone, zones);
    // console.log("plant = ", plant)
    // console.log("zoom = ", zoom)
    // console.log("area = ", area)
    // console.log("current_zone = ", current_zone)
    // console.log("current_zone = ", current_zone?.coordinates[0])
    // console.log("zones = ", zones)
    // console.log("vins = ", vins)
    // Created Main map
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: zoom,
        center: plant,
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        // mapTypeId: 
        mapTypeId: "terrain",
        gestureHandling: "cooperative",
    });


    const area_parameter = new google.maps.Polygon({
        paths: area,
        strokeColor: polygon_stroke_color,
        strokeOpacity: polygon_stroke_opacity,
        strokeWeight: polygon_stroke_width,
        fillColor: polygon_fill_color,
        fillOpacity: polygon_fill_opacity,
    });
    area_parameter.setMap(map);
    // google.maps.Polygon.prototype.my_getBounds = function () {
    //     var bounds = new google.maps.LatLngBounds()
    //     this.getPath().forEach(function (element, index) { bounds.extend(element) })
    //     console.log("bounds", bounds)
    //     return bounds
    // }
    // let lat = area_parameter.my_getBounds().getCenter().lat();
    // let lng = area_parameter.my_getBounds().getCenter().lng();
    // map.setCenter(new google.maps.LatLng(lat, lng));


    const currentZone_parameter = new google.maps.Polygon({
        paths: current_zone?.coordinates,
        strokeColor: domain === "area" ? polygon_stroke_color : "#BE5252",
        strokeOpacity: polygon_stroke_opacity,
        strokeWeight: polygon_stroke_width,
        fillColor: domain === "area" ? polygon_fill_color : "#FF0000",
        fillOpacity: polygon_fill_opacity,
    });
    var bounds = new google.maps.LatLngBounds();
    currentZone_parameter.getPath().forEach(function (path, index) {
        bounds.extend(path);
    });
    map.fitBounds(bounds);
    var areaInfo = []
    // const areaInfo = new google.maps.InfoWindow({
    // content: `<h3 class='label_polygon' style='color:red'> ${current_zone?.name} </h3>` // red message
    if (domain === "area") {
        areaInfo = new google.maps.InfoWindow({
            content:
                '<div id="content" style="text-transform: capitalize">' +
                '<div id="siteNotice"></div>' +
                '<div id="firstHeading" class="firstHeading"  style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">Area Name: ' + (current_zone.name ? current_zone : current_zone.area_name) + '</div>' +
                // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Parking Capacity : ' + current_zone?.parking_capacity + '</div>' +
                // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Plant : ' + current_zone?.plant_data.name + '</div>' +
                // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Area : ' + current_zone?.area_data.name + '</div>' +
                // '<div id="bodyContent">' + current_zone?.description + '</div>' +
                '</div>'
        });
    }
    else {
        areaInfo = new google.maps.InfoWindow({
            content:
                '<div id="content" style="text-transform: capitalize">' +
                '<div id="siteNotice"></div>' +
                '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">' + current_zone.name + '</div>' +
                '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Parking Capacity : ' + current_zone?.parking_capacity + '</div>' +
                '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Plant : ' + current_zone?.plant_data.name + '</div>' +
                '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Area : ' + current_zone?.area_data.name + '</div>' +
                // '<div id="bodyContent">' + current_zone?.description + '</div>' +
                '</div>'
        });
    }
    google.maps.event.addListener(currentZone_parameter, 'click', function (event) {
        areaInfo.setPosition(event.latLng);
        areaInfo.open(map);
    });
    google.maps.event.addListener(map, 'click', function (event) {
        areaInfo.close()
    });
    currentZone_parameter.setMap(map);

    zones?.map((zone, index) => {
        const zone_parameter = new google.maps.Polygon({
            paths: zone.coordinates,
            strokeColor: polygon_stroke_color,
            strokeOpacity: polygon_stroke_opacity,
            strokeWeight: polygon_stroke_width,
            fillColor: polygon_fill_color,
            fillOpacity: polygon_fill_opacity,
        });
        zone_parameter.setMap(map);
        // var bounds = new google.maps.LatLngBounds();
        // zone_parameter.getPath().forEach(function (path, index) {
        //     bounds.extend(path);
        // });
        // map.fitBounds(bounds);
    })


    const infoWindow_marker = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: false
    });
    if (vins) {
        vins.map((d, index) => {
            // console.log("zone vins = ", d, d.coordinates)
            const markers = d.coordinates.map((position, i) => {
                const marker = new google.maps.Marker({
                    position,
                    icon: new_marker,
                    animation: google.maps.Animation.DROP,
                });
                const contentString =
                    '<div id="content">' +
                    '<div id="siteNotice">' +
                    '</div>' +
                    '<span id="firstHeading" class="firstHeading" style="font-size:1rem;font-weight:600;">' + d.vin_number + '</span>' +
                    '</div';
                marker.setTitle(String(d['vin_number']));
                marker.addListener("click", function () {
                    infoWindow_marker.setContent(contentString);
                    infoWindow_marker.open(map, marker);
                });
                google.maps.event.addDomListener(map, 'click', function () {
                    infoWindow_marker.setMap(map);
                });
                map.addListener("click", function () {
                    infoWindow_marker.close();
                });
                return marker;
            });
            new MarkerClusterer({ markers, map });
        })
    }
}
const INDIA_BOUNDS = {
    north: 35.513327,
    south: 6.4626999,
    west: 68.1097,
    east: 97.395358699999991
};
export const listing = (area, region) => {
    // console.log("area = ", area)
    // console.log("region = ", region)
    const INDIA_BOUNDS = {
        north: 35.513327,
        south: 6.4626999,
        west: 68.1097,
        east: 97.395358699999991
    };
    // Created Main map
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: 5,
        center: { lat: 21.511213, lng: 78.821097 },
        restriction: {
            latLngBounds: INDIA_BOUNDS,
            strictBounds: false
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        // mapTypeId: 
        mapTypeId: "terrain",
        gestureHandling: "cooperative",
    });
    const infoWindow_marker = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: false
    });
    const polylist = [];
    area.map((a, index) => {
        var polygon = createPolygon(a, [], region);
        polygon.setMap(map);
        polylist.push(new google.maps.LatLng(parseFloat(polygon.getPosition().lat()), parseFloat(polygon.getPosition().lng())));
    })
    const markers = polylist.map((position, i) => {
        const marker = new google.maps.Marker({
            position,
            // icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            icon: new_marker,
            animation: google.maps.Animation.DROP,
        });
        const areaTitle =
            '<div id="content">' +
            '<div id="siteNotice"></div>' +
            '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">' + area[i].area_name + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Plant : ' + area[i].plant_fk__plant_name + '</div>' +
            // '<div id="bodyContent">' + area[i].area_description + '</div>' +
            '</div>';
        const zoneTitle =
            '<div id="content">' +
            '<div id="siteNotice"></div>' +
            '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">' + area[i].zone_name + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Parent Zone : ' + (area[i].parent_zone_name ? area[i].parent_zone_name : "-") + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Area : ' + area[i].area_fk__area_name + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Plant : ' + area[i].plant_fk__plant_name + '</div>' +
            // '<div id="bodyContent">' + area[i].zone_description + '</div>' +
            '</div>';
        // marker.setTitle(String(position.count));
        // markers can only be keyboard focusable when they have click listeners
        // open info window when marker is clicked
        // marker.addListener("click", () => {
        //         infoWindow_marker.setContent(name);
        //         infoWindow_marker.open(map, marker);
        // });
        marker.addListener("mouseover", function () {
            infoWindow_marker.setContent(region === "area" ? areaTitle : zoneTitle);
            infoWindow_marker.open(map, marker);
        });
        marker.addListener("mouseout", function () {
            infoWindow_marker.close();
        });
        return marker;
    });

    var markerClusterer = new MarkerClusterer({ markers, map, renderer: { render: renderer } });

    // When click on cluster
    markerClusterer.onClusterClick = function (event, cluster, map) {
        map.setZoom(map.zoom + 2);
        var markers = cluster.markers;
        // console.log("%c Cluster Clicked", "background:wheat;color:red")
        map.setCenter(markers[0].getPosition());
        // console.log("mapyyyy = ", map, map.getCenter().lat(), map.getCenter().lng())
    };
    markerClusterer.enableRetinaIcons = true;


    function renderer({ count, position }, stats) {
        // console.log("%c Data = ", "font-size: 24px", count, stats.clusters.markers)
        let nor = (count - stats.clusters.markers.min) / (stats.clusters.markers.max - stats.clusters.markers.min)
        if (isNaN(nor)) { nor = 0.5 }
        const minFont = 12;
        const maxFont = 22;
        const minScale = 55;
        const maxScale = 75;
        // use d3-interpolateRgb to interpolate between red and blue
        const color = interpolateRgb("blue", "#2E75B5")(nor);
        // create svg url with fill color
        const svg = window.btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" height="120" width="120">
        <circle cx="60px" cy="60px" r="36px"  fill="${color}" />
        <circle cx="60px" cy="60px" r="42px" fill-opacity="0.8" fill="${color}" />
        <circle cx="60px" cy="60px" r="48px" fill-opacity="0.5" fill="${color}" />
        <circle cx="60px" cy="60px" r="54px" fill-opacity="0.20" fill="${color}" />
        <circle cx="60px" cy="60px" r="60px" fill-opacity="0.20" fill="${color}" />
    </svg>`);
        // create marker using svg icon
        return new google.maps.Marker({
            position,
            icon: {
                url: `data:image/svg+xml;base64,${svg}`,
                scaledSize: new google.maps.Size(((maxScale - minScale) * nor) + minScale, ((maxScale - minScale) * nor) + minScale)
            },
            label: {
                text: String(count),
                color: "rgba(255,255,255,0.9)",
                fontSize: `${((maxFont - minFont) * nor) + minFont}px`
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
        });
    }

}

export const marker = (data, area, zone) => {
    console.log("data inside map container = ", data, area, zone);
    // console.log("area = ", area);
    // console.log("zone = ", zone);
    // Created Main map
    var last_seen = data.area_fk__area_name == null && data.zone_fk__zone_name == null ?
        "-" :
        data?.zone_fk__zone_name == null ?
            data?.area_fk__area_name
                ?.toLowerCase()[0]
                .toUpperCase() +
            data.area_fk__area_name?.slice(1).toLowerCase()
            :
            data?.zone_fk__zone_name
                ?.toLowerCase()[0]
                .toUpperCase() +
            data.zone_fk__zone_name?.slice(1).toLowerCase()
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: 17,
        center: data['vin_coordinates'][0],
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        mapTypeId: "terrain",
        gestureHandling: "cooperative",
    });
    // Created label to show when click on marker
    const infoWindow_marker = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: false
    });
    // Add a marker clusterer to manage the markers.
    const markers = data['vin_coordinates'].map((position, i) => {
        const marker = new google.maps.Marker({
            position,
            icon: new_marker,
            animation: google.maps.Animation.DROP,
        });
        const contentString =
            '<div id="content">' +
            '<div id="siteNotice"></div>' +
            '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">' + (data['vin_number'] ? data['vin_number'] : "-") + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Vehicle Number : ' + (data['vc_number'] ? data['vc_number'] : "-") + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Vehicle Status : ' + (data['vin_status'] ? data['vin_status'] : "-") + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Last Seen At : ' + (last_seen ? last_seen : "-") + '</div>' +
            '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Type : ' + (data['vin_type'] ? data['vin_type'] : "-") + '</div>' +
            // '<div id="bodyContent">' + data['vc_description'] + '</div>' +
            '</div>';
        marker.setTitle(String(data['vin_number']));
        marker.addListener("click", function () {
            infoWindow_marker.setContent(contentString);
            infoWindow_marker.open(map, marker);
        });
        // marker.addListener("mouseout", function () {
        //     zoneInfo.close()
        //     infoWindow_marker.close();
        // });
        // google.maps.event.addListener(marker, "click", function (event) {
        //     infoWindow_marker.setPosition(event.latLng);
        //     infoWindow_marker.open(map);
        // });
        return marker;
    });
    new MarkerClusterer({ markers, map });



    const currentZone_parameter = new google.maps.Polygon({
        paths: zone?.coordinates,
        strokeColor: polygon_stroke_color,
        strokeOpacity: polygon_stroke_opacity,
        strokeWeight: polygon_stroke_width,
        fillColor: polygon_fill_color,
        fillOpacity: polygon_fill_opacity,
    });
    const zoneInfo = new google.maps.InfoWindow({
        // content: `<h3 class='label_polygon' style='color:red'> ${zone?.name} </h3>` // red message
        content:
            '<div id="content" style="text-transform: capitalize">' +
            '<div id="siteNotice"></div>' +
            '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">' + 'Zone Name : ' + zone.name + '</div>' +
            // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Parking Capacity : ' + zone?.parking_capacity + '</div>' +
            // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Plant : ' + zone?.plant_data.name + '</div>' +
            // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Area : ' + zone?.area_data.name + '</div>' +
            // '<div id="bodyContent">' + zone?.description + '</div>' +
            '</div>'
    });
    // google.maps.event.addListener(currentZone_parameter, 'mouseover', function (event) {
    //     zoneInfo.setPosition(event.latLng);
    //     infoWindow_marker.close();
    //     zoneInfo.open(map);
    // });
    // google.maps.event.addListener(currentZone_parameter, 'mouseout', function (event) {
    //     zoneInfo.close();
    // });
    google.maps.event.addListener(currentZone_parameter, "click", function (event) {
        zoneInfo.setPosition(event.latLng);
        zoneInfo.open(map);
    });
    currentZone_parameter.setMap(map);


    if (!zone.coordinates) {
        const currentArea_parameter = new google.maps.Polygon({
            paths: area?.coordinates,
            strokeColor: polygon_stroke_color,
            strokeOpacity: polygon_stroke_opacity,
            strokeWeight: polygon_stroke_width,
            fillColor: polygon_fill_color,
            fillOpacity: polygon_fill_opacity,
        });
        const areaInfo = new google.maps.InfoWindow({
            // content: `<h3 class='label_polygon' style='color:red'> ${zone?.name} </h3>` // red message
            content:
                '<div id="content" style="text-transform: capitalize">' +
                '<div id="siteNotice"></div>' +
                '<div id="firstHeading" class="firstHeading" style="font-size: 16px;font-weight: 800;margin: 0 0 10px 0">' + 'Area Name : ' + area?.name + '</div>' +
                // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Parking Capacity : ' + zone?.parking_capacity + '</div>' +
                // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Plant : ' + zone?.plant_data.name + '</div>' +
                // '<div style="font-size: 14px;font-weight: 600;margin: 0 0 5px 0">Area : ' + zone?.area_data.name + '</div>' +
                // '<div id="bodyContent">' + zone?.description + '</div>' +
                '</div>'
        });
        // google.maps.event.addListener(currentArea_parameter, 'mouseover', function (event) {
        //     areaInfo.setPosition(event.latLng);
        //     areaInfo.open(map);
        // });
        // google.maps.event.addListener(currentArea_parameter, 'mouseout', function (event) {
        //     areaInfo.close()
        // });
        google.maps.event.addListener(currentArea_parameter, "click", function (event) {
            areaInfo.setPosition(event.latLng);
            areaInfo.open(map);
        });
        google.maps.event.addListener(map, 'click', function (event) {
            areaInfo.close()
            zoneInfo.close()
            infoWindow_marker.close()
        });
        currentArea_parameter.setMap(map);
    }
}


// For testing
export const polyCluster = () => {
    const map = new google.maps.Map(document.getElementById("map_container"), {
        zoom: 17,
        center: {
            lat: 18.6465358,
            lng: 73.8179791
        },
        mapTypeId: "terrain",
    });
    // Define the LatLng coordinates for the polygon's path.
    const a1 = [{
        lat: 18.646678841912546,
        lng: 73.81784478502982
    },
    {
        lat: 18.646190889504197,
        lng: 73.81783405619376
    },
    {
        lat: 18.64620105519368,
        lng: 73.81804863291495
    },
    {
        lat: 18.64668900757281,
        lng: 73.81801644640677
    }
    ];
    const a2 = [{
        lat: 18.646648344928103,
        lng: 73.8173727162432
    },
    {
        lat: 18.646241717945507,
        lng: 73.8173727162432
    },
    {
        lat: 18.64627221500298,
        lng: 73.81766239481681
    },
    {
        lat: 18.646678841912546,
        lng: 73.81768385248893
    }
    ]
    const a3 = [{
        lat: 18.646699173232474,
        lng: 73.81813446360343
    },
    {
        lat: 18.646140061047696,
        lng: 73.8181666501116
    },
    {
        lat: 18.646129895354573,
        lng: 73.81834904032462
    },
    {
        lat: 18.646739835865002,
        lng: 73.81831685381644
    }
    ]
    const createPolygon = (data) => {
        /* console.log("data = ", data) */
        var path = data
        var polygon = new google.maps.Polygon({
            path: path,
            strokeOpacity: 1,
            strokeColor: "red"
        });
        var lastPath = null,
            lastCenter = null;
        polygon.getPosition = function () {
            var path = this.getPath();
            if (lastPath === path) {
                return lastCenter;
            }
            lastPath = path;
            var bounds = new google.maps.LatLngBounds();
            path.forEach(function (latlng, i) {
                bounds.extend(latlng);
            });

            lastCenter = bounds.getCenter()
            return lastCenter;
        };
        polygon.setMap(map);
        // polylist.push({ lat: polygon.getPosition().lat(), lng: polygon.getPosition().lng() });
        polylist.push(new google.maps.LatLng(parseFloat(polygon.getPosition().lat()), parseFloat(polygon.getPosition().lng())));
        return polygon;
    }
    var polylist = []
    createPolygon(a1)
    createPolygon(a2)
    createPolygon(a3)


    // console.log("polylist = ", polylist[0].lat())
    const markers = polylist.map((position, i) => {
        // console.log("position = ", position)
        const marker = new google.maps.Marker({
            position,
            optimized: true
        });
        return marker;
    });

    // Add a marker clusterer to manage the markers.
    const markerClusterer = new MarkerClusterer({ map, polylist });
    // markerClusterer.clearMarkers()
    // console.log("fdd = ",markerClusterer.getMarkers())
    // google.maps.event.addListener(markerClusterer, 'click', function (cluster) {
    //     console.log("inside = ",cluster)
    //     var clusterMarks = cluster.getMarkers();
    //     for (var i in clusterMarks) {
    //         clusterMarks[i].setVisible(false);
    //     }

    //     markerClusterer.repaint();
    // })
    // google.maps.event.addListener(map, 'idle', function (e) {
    //     console.log("idle called")
    //     markers.map((marker, i) => {
    //         console.log("marker = ", marker)
    //         marker.setVisible(false)
    //     })
    // });

}
